export default __webpack_public_path__ + "static/media/9.7a6cfe1a.png";